import { styled } from "@mui/material"
import { palette } from "view/themes/palette"

export const Wrapp = styled("div")<{ $color: string }>(({ $color }) => ({
  width: 378,
  height: 618,
  borderRadius: 16,
  background: $color,
  color: "#808080",
  position: "relative",
  overflow: "hidden",
  border: `1px solid ${palette.grey200}`,
}))

export const MenuIcon = styled("div")(() => ({
  position: "absolute",
  top: 16,
  left: 16,
}))

export const Top = styled("div")<{ $primaryBg: string; $bg: string }>(
  ({ $primaryBg, $bg }) => ({
    padding: 16,
    marginBottom: 24,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: 1,
    background: `linear-gradient(180deg, ${$primaryBg} 0%, ${$bg} 100%)`,
  })
)

export const TopIcon = styled("div")<{ $bg: string }>(({ $bg }) => ({
  width: 64,
  height: 64,
  borderRadius: "100%",
  background: $bg,
  margin: "8px 0px 24px",
  position: "relative",

  svg: {
    position: "absolute",
    top: 0,
    left: 0,
  },
}))

export const Title = styled("div")<{ $color: string }>(({ $color }) => ({
  lineHeight: "20px",
  fontWeight: 600,
  color: $color,
}))

export const Subtitle = styled("div")(() => ({
  marginTop: 16,
  fontSize: 12,
  lineHeight: "18px",
}))

export const Content = styled("div")(() => ({
  padding: "0 16px 16px",
}))

export const Input = styled("div")<{ $color: string; $border: string }>(
  ({ $color, $border }) => ({
    padding: "12px 16px",
    border: `1px solid ${$border}`,
    borderRadius: 6,
    color: $color,
    lineHeight: "24px",
    position: "relative",
    marginBottom: 27,
    flex: 1,

    img: {
      position: "absolute",
      top: 12,
      right: 16,
    },
  })
)

export const InputLabel = styled("div")<{ $bg: string }>(({ $bg }) => ({
  position: "absolute",
  top: -9,
  padding: "0 4px",
  backgroundColor: $bg,
  color: "#808080",
  fontSize: 12,
  lineHeight: "18px",
}))

export const CardSecret = styled("div")(() => ({
  display: "flex",
  gap: 6,
}))

export const Checkbox = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 12,
}))

export const CheckboxIcon = styled("div")<{ $bg: string }>(({ $bg }) => ({
  width: 20,
  height: 20,
  backgroundColor: $bg,
  borderRadius: 4,
  position: "relative",

  svg: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 10,
    height: 8,
  },
}))

export const ChecboxLabel = styled("div")(() => ({
  fontSize: 14,
}))

export const Address = styled("div")<{ $linkColor: string }>(
  ({ $linkColor }) => ({
    marginTop: 27,
    fontSize: 12,
    lineHeight: "18px",

    span: {
      color: $linkColor,
    },
  })
)

export const Btns = styled("div")(() => ({
  display: "flex",
  gap: 16,
  width: "100%",
  marginTop: 34,
}))

export const BackBtn = styled("div")<{ $bg: string; $color: string }>(
  ({ $bg, $color }) => ({
    fontSize: 16,
    lineHeight: "24px",
    background: $bg,
    padding: 12,
    textAlign: "center",
    borderRadius: 6,
    color: $color,
    width: 150,
  })
)

export const SubmitBtn = styled("div")<{ $bg: string; $color: string }>(
  ({ $bg, $color }) => ({
    fontSize: 16,
    lineHeight: "24px",
    background: $bg,
    padding: 12,
    textAlign: "center",
    borderRadius: 6,
    color: $color,
    width: "100%",
  })
)
